import OverrideServerPropertiesIntro from "../../../../contents/docs/integrate/feature-flags-code/_snippets/override-server-properties/override-server-properties-intro.mdx";
import OverrideGeoIPPropertiesSDK from "../../../../contents/docs/integrate/feature-flags-code/_snippets/override-server-properties/override-geoip-properties-SDKs.mdx";
import * as React from 'react';
export default {
  OverrideServerPropertiesIntro,
  OverrideGeoIPPropertiesSDK,
  React
};